// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__nrzSR","inputWrap":"Table_inputWrap__2mXHZ","col":"Table_col__3OWCF","bmiTooltip":"Table_bmiTooltip__2f597"};